import { observer } from 'mobx-react'
import React, { ReactElement, useEffect } from 'react'
import { Redirect, useLocation } from 'react-router-dom'

import {
   getSsoCodeFromSearch,
   isLoggedIn,
   LoginController,
   SsoExchangeController,
   stripSsoCodeFromUrl
} from '@flowwai-frontend/bps-officer-web/login'
import { HOME_ROUTE_PATH } from '@flowwai-frontend/bps-officer-web/common/data-access'

const LoginRoute = (): ReactElement => {
   const location = useLocation()
   const loggedIn = isLoggedIn()

   useEffect(() => {
      if (loggedIn) {
         stripSsoCodeFromUrl()
      }
   }, [])

   if (loggedIn) {
      return <Redirect to={HOME_ROUTE_PATH} />
   }

   const ssoCode = getSsoCodeFromSearch(location.search)

   return ssoCode ? (
      <SsoExchangeController ssoCode={ssoCode} />
   ) : (
      <LoginController />
   )
}

export default observer(LoginRoute)
